import * as Sentry from "@sentry/react";
import { TagName, TagValue } from "../tags/tag-types";

export function setMonitoringTag(tagName: TagName, value: TagValue) {
    Sentry.setTag(tagName, value);
}
